<template>
  <div>
    <div v-if="customer" class="customer-info">
      <div class="base-customer-information">
        <div class="customer-user-info">
          <div class="input-wrapper">
            <label for="name-customer">Название:</label>
            <input
              id="name-customer"
              class="input-field"
              type="text"
              v-model="form.name"
            >
          </div>

          <div class="input-wrapper">
            <label for="director-customer">Руководитель:</label>
            <input
              id="director-customer"
              class="input-field"
              type="text"
              v-model="form.director"
            >
          </div>

          <div class="input-wrapper">
            <label for="inn-customer">ИНН:</label>
            <input
              id="inn-customer"
              class="input-field"
              type="text"
              v-model="form.inn"
            >
          </div>

          <div class="input-wrapper">
            <label for="phone-customer">Телефон:</label>
            <input
              id="phone-customer"
              class="input-field"
              type="text"
              v-model="form.phone"
            >
          </div>

          <div class="input-wrapper">
            <label for="email-customer">Email:</label>
            <input
              id="email-customer"
              class="input-field"
              type="text"
              v-model="form.email"
            >
          </div>

          <div class="input-wrapper">
            <label for="address-customer">Адрес:</label>
            <input
              id="address-customer"
              class="input-field"
              type="text"
              v-model="form.address"
            >
          </div>
        </div>

        <div class="input-wrapper conditions-wrapper">
          <label for="conditions-customer">Условия:</label>
          <textarea
            id="conditions-customer"
            class="input-field"
            rows="8"
            v-model="form.transport_conditions"
          />
        </div>
      </div>

      <button
        class="save-button"
        type="button"
        :disabled="!isModified || saving"
        @click="saveChanges"
      >
        {{ saving ? 'Сохранение…' : 'Сохранить' }}
      </button>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import {
  customerToForm,
  isCustomerFormModified,
} from '@/pages/customer/customerState.mjs'

export default {
  name: 'CustomerInfo',
  props: {
    customer: { type: Object, required: true },
    saving: { type: Boolean, default: false },
  },
  emits: ['updateCustomer'],
  setup(props, { emit }) {
    const form = ref(customerToForm(props.customer))

    watch(
      () => props.customer,
      (next) => {
        if (!next) return
        form.value = customerToForm(next)
      },
      { deep: true },
    )

    const isModified = computed(() =>
      isCustomerFormModified(form.value, props.customer),
    )

    const saveChanges = () => {
      emit('updateCustomer', { ...form.value })
    }

    return {
      form,
      isModified,
      saveChanges,
    }
  },
}
</script>

<style scoped>
.base-customer-information {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.customer-user-info {
  margin-top: 20px;
}

.input-wrapper {
  margin-left: 20px;
  margin-top: 5px;
  max-width: 355px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.conditions-wrapper {
  max-width: none;
  align-items: flex-start;
}

.input-wrapper * {
  padding: 3px;
}

.input-field {
  border-radius: 5px;
  border: 1px solid rgba(183, 183, 183, 1);
}

.save-button {
  margin-top: 10px;
  margin-left: 20px;
  padding: 8px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.save-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

#conditions-customer {
  height: 100px;
  width: 550px;
  max-width: 100%;
}
</style>
